import React from 'react';

import { Select, MenuItem, FormControl } from '@mui/material';

import classes from './ToolkitsFilters.module.scss';

const selectStyle = {
    backgroundColor: '#fff',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: 500,
    minWidth: '180px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e3e3e0',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bb3a90',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bb3a90',
    },
};

const ToolkitsFilters = ({ categories, filters, onChange }) => {
    const handleAccessChange = (e) => {
        const value = e.target.value;
        onChange({ has_access: value === '' ? undefined : value });
    };

    const handleCategoryChange = (e) => {
        const value = e.target.value;
        onChange({ category: value === '' ? undefined : value });
    };

    return (
        <div className={classes['wrapper']}>
            <div className={classes['title']}>
                <h4>Filters</h4>
            </div>
            <div className={classes['controls']}>
                <FormControl size="small">
                    <Select
                        value={filters?.has_access ?? ''}
                        onChange={handleAccessChange}
                        displayEmpty
                        sx={selectStyle}
                        renderValue={(selected) => {
                            if (selected === '') return <span className={classes['placeholder']}>Access</span>;
                            if (selected === 'true') return 'Unlocked';
                            if (selected === 'false') return 'Locked';
                            return selected;
                        }}
                    >
                        <MenuItem value=""><em>All</em></MenuItem>
                        <MenuItem value="true">Unlocked</MenuItem>
                        <MenuItem value="false">Locked</MenuItem>
                    </Select>
                </FormControl>

                <FormControl size="small">
                    <Select
                        value={filters?.category ?? ''}
                        onChange={handleCategoryChange}
                        displayEmpty
                        sx={selectStyle}
                        renderValue={(selected) => {
                            if (selected === '') return <span className={classes['placeholder']}>Tool type</span>;
                            const found = categories?.find((c) => String(c.id) === String(selected));
                            return found ? found.name : selected;
                        }}
                    >
                        <MenuItem value=""><em>All</em></MenuItem>
                        {categories?.map((category) => (
                            <MenuItem key={category.id} value={String(category.id)}>
                                {category.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
};

export default ToolkitsFilters;
